module.exports = (__webpack_require__("bricks/next-builder:XuQu"))("IP2g");